import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {SubnavComponent, SubnavItem} from '../../../components/subnav/subnav.component';
import {TitleBreadcrumbsChangedAction} from '../../../../core/actions/title.actions';
import {AppsService} from '../../../../core/services/apps.service';
import {UrlService} from '../../../../core/services/url.service';
import {Store} from '@ngrx/store';
import {AppState} from '../../../../app/app.state';
import {AsideService} from '../../../../core/services/aside.service';
import {AppId} from '../../../../shared/models/app';
import {TilesService} from '../../../../core/services/tiles.service';
import {RouterOutlet} from '@angular/router';

@Component({
  selector: 'motn-configuration-mosaic',
  templateUrl: './configuration-mosaic.component.html',
  styleUrls: ['./configuration-mosaic.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SubnavComponent,
    RouterOutlet,
  ],
})
export class ConfigurationMosaicComponent implements OnInit, OnDestroy {
  appId: AppId;
  subnavItems: SubnavItem[];

  constructor(
    private appsService: AppsService,
    private tilesService: TilesService,
    private asideService: AsideService,
    private store: Store<AppState>,
  ) {

  }

  ngOnInit(): void {
    this.updateTitle();
    this.appId = this.appsService.currentAppId;
    this.populateSubnav();
  }

  ngOnDestroy() {
  }

  private populateSubnav() {
    this.subnavItems = [
      {
        text: 'Tile Groups',
        href: UrlService.makeMosaicConfigurationTileGroupsUrl(this.appId),
      },
      {
        text: 'App Settings',
        href: UrlService.makeMosaicConfigurationAppUrl(this.appId),
      },
      // {
      //   text: 'Tiles',
      //   href: UrlService.makeMosaicConfigurationTilesUrl(this.appId),
      // },
    ];
  }

  private updateTitle() {
    this.store.dispatch(new TitleBreadcrumbsChangedAction(
      [
        {
          path: UrlService.makeMosaicDashboardUrl(this.appId),
          text: 'Mosaic',
        },
        {
          text: 'Configuration',
        },
      ],
    ));
  }
}
